<div id="main-navigation" class="nav"
  [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

  <!-- Vertical Navigation Layout -->
  @if (layout === 'vertical') {
    @for (item of navigationModel; track item) {
      @if (item.type=='group') {
        <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
      }
      @if (item.type=='collapse') {
        <fuse-nav-vertical-collapse [item]="item"></fuse-nav-vertical-collapse>
      }
      @if (item.type=='item') {
        <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
      }
    }
  }
  <!-- / Vertical Navigation Layout -->

  <!-- Horizontal Navigation Layout -->
  @if (layout === 'horizontal') {
    @for (item of navigationModel; track item) {
      @if (item.type=='group') {
        <fuse-nav-horizontal-collapse [item]="item"></fuse-nav-horizontal-collapse>
      }
      @if (item.type=='collapse') {
        <fuse-nav-horizontal-collapse [item]="item"></fuse-nav-horizontal-collapse>
      }
      @if (item.type=='item') {
        <fuse-nav-horizontal-item [item]="item"></fuse-nav-horizontal-item>
      }
    }
  }
  <!-- / Horizontal Navigation Layout -->

</div>
